import { useRouteMatch } from 'react-router-dom';
import { LOCAL_STORAGE_KEY } from 'state/localStorage';
import { WILDFIRE_PROGRESSION_MODEL_ROUTE_PATH } from '../../constants';

type ProgressionModelParams = {
  geoEventId: string;
  modelId: string;
};

export const useMapLayersStateStorageKey = (): string => {
  const progressionModelMatch = useRouteMatch<ProgressionModelParams>(
    WILDFIRE_PROGRESSION_MODEL_ROUTE_PATH,
  );

  const insideProgressionModelPage = Boolean(progressionModelMatch);

  return insideProgressionModelPage
    ? LOCAL_STORAGE_KEY.MAP_LAYERS_PROGRESSION_MODEL
    : LOCAL_STORAGE_KEY.MAP_LAYERS;
};
